var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "kp-container-wrapper" },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("CLIENT_HOME_KPCONTACT"))),
      ]),
      _vm._l(_vm.data, function (list) {
        return _c(
          "div",
          { key: list.key, staticClass: "wl-client-container" },
          _vm._l(list, function (item) {
            return _c(
              "div",
              { key: item.key, staticClass: "wl-contact-item border-normal" },
              [
                _c(
                  "div",
                  { staticClass: "flex item-center" },
                  [
                    _c("svg-icon", {
                      attrs: {
                        "icon-name": "user-usename",
                        "icon-color": "#ccced2",
                        size: 24,
                      },
                    }),
                    item.cnUserName
                      ? _c("span", [_vm._v(_vm._s(item.cnUserName))])
                      : _vm._e(),
                    item.userName
                      ? _c("span", [_vm._v(_vm._s(item.userName))])
                      : _vm._e(),
                    item.profitCenter
                      ? _c("span", [
                          _vm._v("(" + _vm._s(item.profitCenter) + ")"),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex item-center" },
                  [
                    _c("svg-icon", {
                      attrs: {
                        "icon-name": "user-position",
                        "icon-color": "#ccced2",
                        size: 24,
                      },
                    }),
                    _c("span", [_vm._v(_vm._s(item.title))]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex item-center" },
                  [
                    _c("svg-icon", {
                      attrs: {
                        "icon-name": "user-email",
                        "icon-color": "#ccced2",
                        size: 24,
                      },
                    }),
                    _c("span", [_vm._v(_vm._s(item.email))]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex item-center" },
                  [
                    _c("svg-icon", {
                      attrs: {
                        "icon-name": "user-phone",
                        "icon-color": "#ccced2",
                        size: 24,
                      },
                    }),
                    _c("span", [_vm._v(_vm._s(item.phone))]),
                  ],
                  1
                ),
              ]
            )
          }),
          0
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }